import { render } from "./sales_notification.vue?vue&type=template&id=e7d380e4&scoped=true"
import script from "./sales_notification.vue?vue&type=script&lang=js"
export * from "./sales_notification.vue?vue&type=script&lang=js"

import "./sales_notification.vue?vue&type=style&index=0&id=e7d380e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7d380e4"]])

export default __exports__